import {
	CreateClassifierRequestProps,
	UpdateClassifierRequestProps,
} from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { FindDealClassifiersRes, DealClassifierTct } from '@dealstack/shared/lib/generated';
import { GetDealClassifierFilters } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/hooks/useGetDealClassifiers';

export const getDealClassifiers = async (
	endpoint: string,
	filters: { filters: GetDealClassifierFilters },
	signal?: AbortSignal
) => {
	const response = await makeRequest<ApiV1.Response<FindDealClassifiersRes>>(
		{
			endpoint,
			method: HTTP_METHOD.GET,
			queryString: filters,
		},
		{
			abortSignal: signal,
		}
	);
	return response;
};

export const updateClassifierRequest = async ({
	dealId,
	dealClassifierId,
	classifierParentId,
	name,
	archive,
}: UpdateClassifierRequestProps): Promise<string> => {
	const response = await makeRequest<{ id: string }>({
		endpoint: formatUnicorn(API_PATHS.DEAL_DEALID_CLASSIFIERS_DEALCLASSIFIERID_PUT, {
			dealId,
			dealClassifierId,
		}),
		method: HTTP_METHOD.PUT,
		body: JSON.stringify({ name, archive, classifierParentId }),
	});

	return response.id;
};

export const createClassifierRequest = async ({
	dealId,
	name,
	classifierParentId,
}: CreateClassifierRequestProps): Promise<DealClassifierTct | undefined> => {
	const response = await makeRequest<ApiV1.Response<DealClassifierTct[]>>({
		endpoint: formatUnicorn(API_PATHS.DEAL_DEALID_CLASSIFIERS_POST, {
			dealId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({ name, classifierParentId }),
	});

	return response?.payload?.[0];
};
